<template src="./TabProductComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {AppConstant, CommonText} from "@/supports/app.constant";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import IconRotateRight from "@/components/icons/IconRotateRight.vue";
import {computed, onMounted, reactive, ref, watch} from "vue";
import {useSyncKiotviet} from "@/stores/syncKiotviet.js";
import {useAccountStore} from "@/stores/account.js";
import {useRouter} from "vue-router";
import ModalWarehouseListComponent from "@/components/modals/modal-warehouse-list/ModalWarehouseListComponent.vue";
import {useWarehouseStore} from "@/stores/warehouse.js";

export default {
  name: 'TabProductComponent',
  components: {
    ModalWarehouseListComponent,
    IconRotateRight,
    InputCheckboxOne,
    InputDateTimeNormal,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  props: {
    tabCurrent: {
      type: Number,
      required: false,
      default: () => 1
    },
  },
  setup(props) {
    const dataHeaderTable =  ref({
      productName: {
        label: 'Tên sản phẩm',
        order: 2,
        width: '25%',
      },
      productCode: {
        label: 'Mã sản phẩm',
        order: 3,
        width: '15%',
      },
      productQuantity: {
        label: 'Số lượng',
        order: 4,
        width: '15%',
      },
      productPrice: {
        label: 'Giá sản phẩm',
        order: 5,
        width: '15%',
      },
      productUnit: {
        label: 'Đơn vị sản phẩm',
        order: 6,
        width: '15%',
      },
      createdAt: {
        label: 'Ngày tạo',
        order: 7,
        width: '15%',
      },
    })
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])
    const labelButtonSync = ref('Đồng bộ sản phẩm')
    const urlOrigin = ref('/setting/sync-kiotviet');
    const messError = ref('');
    const labelSelectWareHouse = ref('Đồng Bộ')
    const eventClickShowModalWarehouse = ref(false)
    const listWarehousesSelected = ref([])
    const typeSelectWarehouse = ref('single')
    const warehouseSelected = ref([])
    const isLoading = ref(false)
    const stateModal = reactive({
      modalWarehouseList: null,
    })

    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_SYNC_KIOTVIET))
    const selectLimit = ref(CommonService.showDropdownLimitRecord())
    const limitDefault = ref(10)
    const syncKiotvietStore = useSyncKiotviet()
    const accountStore = useAccountStore()
    const warehouseStore = useWarehouseStore()
    const router = useRouter()

    watch(() => props.tabCurrent, (newTab) => {
      if(newTab === AppConstant.TAB_PRODUCT_KIOTVIET) {
        getListDataKiotviet(router.currentRoute.value.query.page ?? AppConstant.PAGE_DEFAULT);
      }
    });

    onMounted(() => {
      if(props.tabCurrent === AppConstant.TAB_PRODUCT_KIOTVIET) {
        getListDataKiotviet(router.currentRoute.value.query.page ?? AppConstant.PAGE_DEFAULT);
      }
      stateModal.modalWarehouseList = new bootstrap.Modal('#modalWarehouse', {})
    });

    const listDataProduct = computed(() => {
      return syncKiotvietStore.datas;
    });

    const paginate = computed(() => {
      return syncKiotvietStore.paginate;
    });

    watch(() => syncKiotvietStore.datas, (newlistDataProduct) => {
      newlistDataProduct.forEach((product) => {
        if(checkItems.value[product.id] === undefined) {
          checkItems.value[product.id] = false
        }
      })
    });

    function emitPage(page) {
      const limit = limitDefault.value ?? 10;
      getListDataKiotviet(page, limit);
    }

    async function getListDataKiotviet(page = 0, take = 10) {
      const params = {
        m_company_id: accountStore.account.company.id,
        page: page,
        take: take
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-kiotviet/get-list-products';

      return await syncKiotvietStore.getlistDataProduct(url, params);
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      listItemSelected.value = []
      listDataProduct.value.forEach((product) => {
        checkItems.value[product.id] = value
        if (value) listItemSelected.value.push(product.id)
      })
    }

    function onChangeSelectItem(value, id) {
      checkItems.value[id] = value

      if (value) {
        if (!listItemSelected.value.includes(id)) {
          listItemSelected.value.push(id)
        }
      } else {
        const index = listItemSelected.value.indexOf(id)
        if (index !== -1) {
          listItemSelected.value.splice(index, 1)
        }
      }

      const allSelected = listDataProduct.value.every(
          (item) => checkItems.value[item.id]
      )
      checkAll.value = allSelected
    }

    function onChangeAction(value) {
      switch (parseInt(value)) {
        case AppConstant.ACTION_TYPE_SYNC_KIOTVIET:
          if (listItemSelected.value.length === 0) {
            CommonService.showAlertPopup({
              title: 'Vui lòng chọn dữ liệu để thực hiện!',
              icon: "warning",
              showConfirmButton: false,
              timer: 1500,
              width: '800px'
            });
          } else {
            showModalWarehouseList()
          }
          break;
      }
    }

    async function syncSelectedKiotvietProducts(listWarehousesSelectedCurrent) {
      listWarehousesSelected.value = listWarehousesSelectedCurrent;

      messError.value = '';

      if (listItemSelected.value.length === 0) {
        messError.value = 'Vui lòng chọn ít nhất 1 sản phẩm để đồng bộ.';
        return;
      }

      if (listWarehousesSelected.value.length === 0) {
        messError.value = 'Vui lòng chọn ít nhất 1 kho hàng để đồng bộ.';
        return;
      }

      listWarehousesSelected.value.forEach((item) => {
        warehouseSelected.value.push(item.id)
      })

      const params = {
        m_company_id: accountStore.account.company.id,
        product_ids: listItemSelected.value,
        warehouse_ids: warehouseSelected.value,
      };

      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-kiotviet/sync-products';
      try {
        const result = await syncKiotvietStore.syncProducts(url, params);

        if (result?.status === 'success') {
          CommonService.showAlertPopup({
            title: result?.message || 'Đồng bộ thành công!',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false,
            width: '800px',
          });
          await getListDataKiotviet();
        } else {
          messError.value = result?.message || 'Đồng bộ thất bại. Vui lòng thử lại.';
        }
      } catch (error) {
        console.error('Lỗi đồng bộ KiotViet:', error);
        messError.value = 'Lỗi máy chủ hoặc kết nối mạng. Vui lòng thử lại.';
      }
    }

    function onChangeLimit(value) {
      const currentLimit = limitDefault.value
      limitDefault.value = value
      if(currentLimit > 0) {
        getListDataKiotviet(AppConstant.PAGE_DEFAULT, limitDefault.value)
      }
    }

    const removeError = () => {
      messError.value = '';
    };

    function showModalWarehouseList() {
      eventClickShowModalWarehouse.value = true
      isLoading.value = true
    }

    function showModalWarehouse(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModalWarehouse.value = false
          isLoading.value = false
          stateModal.modalWarehouseList.show()
        }, 1000);
        return;
      }
      stateModal.modalWarehouseList.hide()
    }

    function eventSearchWarehouse(isSearch) {
      if(!eventClickShowModalWarehouse.value) {
        isLoading.value = isSearch
      }
    }

    return {
      dataHeaderTable,
      labelButtonSync,
      urlOrigin,
      syncKiotvietStore,
      accountStore,
      checkAll,
      listDataProduct,
      paginate,
      selectAction,
      selectLimit,
      checkItems,
      onChangeSelectItem,
      onChangeAction,
      emitPage,
      onChangeSelectAll,
      onChangeLimit,
      CommonService,
      CommonText,
      AppConstant,
      messError,
      removeError,
      labelSelectWareHouse,
      showModalWarehouseList,
      eventClickShowModalWarehouse,
      listWarehousesSelected,
      typeSelectWarehouse,
      isLoading,
      syncSelectedKiotvietProducts,
      eventSearchWarehouse,
      showModalWarehouse
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;

  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }

  .container-fluid {
    padding-top: 30px;

    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46, 35, 94, .07);

      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;

        .list-product-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }

          table {
            display: block;
            overflow-x: auto;
            white-space: nowrap;
            td {
              max-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;

            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
